import { render, staticRenderFns } from "./facet-sidebar.vue?vue&type=template&id=3fbaca80&"
import script from "./facet-sidebar.vue?vue&type=script&lang=js&"
export * from "./facet-sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports